module.exports = "https://www.gc-pro.gnp.com.mx/3b19b7ba7d598156abf72edbb890f6a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-cobranza.svg
// module id = 323
// module chunks = 0